import {Injectable} from '@angular/core';
import {AccountLevel3Guard} from './account-level-3.guard';
import {SwalUtil} from '../../util/swal-util';

@Injectable({
  providedIn: 'root'
})
export class IncrementLimit3Guard extends AccountLevel3Guard{

  protected showMessage(): void {
    SwalUtil.fireGenericMessage("Atención", "El aumento de límite ya fue solicitado y aprobado. En caso de querer volver a" +
      " extenderlo por favor envía un mail con el asunto \"Aumento de Límite\" a validaciones@mercadocheque.com. ");
  }

  protected showMessage2() {
    SwalUtil.fireGenericMessage("Atención", "Ya existe una solicitud de Aumento de Límite en progreso y está siendo revisada por un operador. ");
  }
}
